import React from 'react'
import { Card as CardBase } from '@chilecompra/react-kit/components'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  background: ${props => props.theme.palette.brand.gray3};
  width: 100%;
`

export const BoldText = styled('strong')``

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    box-shadow: 0 4px 10px rgba(118, 138, 162, 0.2);
    cursor: pointer;
  }
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ margin, minHeight, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Image = styled('img')`
  width: 100%;
  height: auto;
`
